export enum MessageSeverity {
  Info = 0,
  Warning = 1,
  Error = 2,
  Success = 3,
}

export enum ContentTypeEnum {
  Text = 1,
  Html = 2,
}

// Sigma: MessageTypeEnum values from backend
export enum MessageTypeEnum {
  AggregationProgress = 6,
  BalanceChange = 10,
}

export interface MessageData {
  message: string;
  title?: string;
  type: "info" | "warning" | "error" | "success";
  contentType?: "text" | "html";
  localizedMessages?: {
    en: string;
    ka: string;
    ru: string;
    tr: string;
  };
}

export interface ParsedSignalRData {
  CorrelationId?: string;
  Initiator?: string;
  Message?: string;
  Severity?: MessageSeverity;
  ContentType?: ContentTypeEnum;
  AggregationId?: string;
  CurrentScore?: number;
  KeyId?: string;
  MessageType?: number;
  Username?: string;
  PointsAdded?: number;
  PopUpMessage?: boolean;
  popUpMessage?: boolean;
  UpdatedScore?: number;
  LeaderboardId?: number;
  ProgressId?: number;
  Progress?: number;
  CoinId?: string;
  Amount?: number;
  AddedAmount?: number;
  ShouldLockProgress?: boolean;
  Placement?: number;
  ExternalId?: number;
  type?: string;
  result?: number;
  localizedMessages?: {
    en: string;
    ka: string;
    ru: string;
    tr: string;
  };
  OldProgress?: number;
  NewProgress?: number;
  Delta?: number;
  CurrentStep?: number;
  TotalSteps?: number;
  PromotionId?: string;
  CurrentProgress?: number;
  RewardBarId?: number;
  RaffleRecordId?: number | string;
  RaffleRecordID?: number | string;
  RaffleExternalId?: number | string;
  RaffleId?: number | string;
  RaffleID?: number | string;
  MyTotalTickets?: number | string;
  PlayerTicketsCount?: number | string;
  UserTicketsCount?: number | string;
  MyTicketsCount?: number | string;
  TotalTicketsCount?: number | string;
  TotalTickets?: number | string;
  totalTickets?: number | string;
  AllTicketsCount?: number | string;
  TicketsCount?: number | string;
  AddedticketsCount?: number | string;
  AddedTicketsCount?: number | string;
}
